import React from 'react';
import { Unplug } from 'lucide-react';
import { KeyboardKeyButton } from 'components';

interface Props {
  disconnect(): void;
}

const VMDisconnectButton = (props: Props) => {
  return (
    <KeyboardKeyButton
      type="button"
      title="Disconnect"
      aria-label="Disconnect"
      {...props}
      onClick={() => props.disconnect()}
    >
      <Unplug size={20} aria-hidden={true} />
    </KeyboardKeyButton>
  );
};

export { VMDisconnectButton };
